<template>
  <div class="execution">
    <basic-container>
      <my-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :permission="permissionList"
        :table-loading="tableLoading"
        :option="tableOption"
        v-model="form"
        @on-load="getPage"
        @refresh-change="refreshChange"
        @row-update="handleUpdate"
        @row-save="handleSave"
        @row-del="handleDel"
        @sort-change="sortChange"
        @search-change="searchChange"
      >
        <template slot="menuLeft" slot-scope="scope">
          <el-button
            type="primary"
            v-if="permissions['chain:systemdictionaryitem2:add']"
            size="small"
            @click="add"
          >
            新增
          </el-button>
        </template>
        <template slot="menu" slot-scope="{ row }">
          <el-button
            type="text"
            v-if="permissions['chain:systemdictionaryitem2:edit']"
            size="small"
            plain
            @click="edit(row)"
          >
            编辑</el-button
          >
        </template>
        <template slot="searchMenu" slot-scope="{ row, done }">
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="
                margin-right: 20px;
                margin-bottom: 0;
                background: #fff;
              "
              @click="searchChange(row)"
            >
              筛选
            </el-button>
            <span class="reset" @click="reset"> 重置筛选条件 </span>
          </div>
        </template>
      </my-crud>

      <el-dialog
        :title="`${form.id ? '编辑' : '新增'}标签类型`"
        width="640px"
        class="add-dialog"
        :visible.sync="visible"
        :close-on-click-modal="false"
      >
        <avue-form ref="form2" v-model="form" :option="tableOption">
        </avue-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="visible = false">取 消</el-button>

          <el-button type="primary" size="small" @click="submitForm('form2')"
            >保存</el-button
          >
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import {
  getPage,
  getObj,
  addObj,
  putObj,
  delObj,
} from "@/api/chain/systemdictionaryitem";
import { tableOption } from "@/const/crud/chain/systemdictionaryitem";
import { mapGetters } from "vuex";

export default {
  name: "systemdictionaryitem2",
  data() {
    return {
      visible: false,
      form: {},
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: [], //降序字段
      },
      paramsSearch: {},
      tableLoading: false,
      tableOption: tableOption(this),
    };
  },
  created() {},
  mounted: function () {},
  computed: {
    ...mapGetters(["permissions"]),
    permissionList() {
      return {
        addBtn: this.permissions["chain:systemdictionaryitem2:add"]
          ? true
          : false,
        delBtn: this.permissions["chain:systemdictionaryitem2:del"]
          ? true
          : false,
        editBtn: this.permissions["chain:systemdictionaryitem2:edit"]
          ? true
          : false,
        viewBtn: this.permissions["chain:systemdictionaryitem2:get"]
          ? true
          : false,
      };
    },
  },
  methods: {
    edit(row) {
      this.form = row;
      this.visible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.id) {
            this.form.itemValue = this.form.itemName;
            putObj(this.form)
              .then((response) => {
                this.$message({
                  showClose: true,
                  message: "修改成功",
                  type: "success",
                });
                this.visible = false;
                this.$refs.form2.allDisabled = false;
                this.$refs.form2.resetForm();
                console.info();
                this.getPage(this.page);
              })
              .catch(() => {});
          } else {
            this.form.itemValue = this.form.itemName;
            addObj(this.form)
              .then((response) => {
                this.$message({
                  showClose: true,
                  message: "添加成功",
                  type: "success",
                });
                this.$refs.form2.allDisabled = false;
                this.$refs.form2.resetForm();
                this.visible = false;
                this.getPage(this.page);
              })
              .catch(() => {
                //   loading();
              });
          }
        } else {
          return false;
        }
      });
    },
    add() {
      // debugger
      this.form = {};
      this.visible = true;

    },
    reset() {
      this.$refs.crud.searchReset();
    },
    searchChange(params, done) {
      params = this.filterForm(params);
      this.paramsSearch = params;
      this.page.currentPage = 1;
      this.getPage(this.page, params);
      //   done();
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params) {
      this.tableLoading = true;
      getPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前删除数据的行数
     *
     **/
    handleDel: function (row, index) {
      let _this = this;
      this.$confirm("是否确认删除此数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delObj(row.id);
        })
        .then((data) => {
          _this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getPage(this.page);
        })
        .catch(function (err) {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate: function (row, index, done, loading) {
      row.itemValue = row.itemName;
      putObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
        })
        .catch(() => {
          loading();
        });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave: function (row, done) {
      row.itemValue = row.itemName;
      addObj(row)
        .then((response) => {
          this.$message({
            showClose: true,
            message: "添加成功",
            type: "success",
          });
          done();
          this.getPage(this.page);
        })
        .catch(() => {
          //   loading();
        });
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/newPage.scss";

// /deep/.my-dialog {
// .custom-modal {
//    .avue-dialog__footer {
//     border: none!important;
//   }
// }
// }
// /deep/.avue-crud__dialog__menu{
//     display: none;
// }
/deep/.add-dialog {
  .el-collapse-item__wrap .avue-form__group--flex {
    background: #fff;
  }
  .el-dialog__header {
    border-bottom: 1px solid #ededf0;
  }
  .el-dialog__footer {
    background: #fff;
    text-align: center;
  }
  .el-input.is-disabled .el-input__inner {
    background: #F5F7FA;
    border-color: #ededf0;
  }
}
</style>
